<template>
    <div>
        <van-popup
            v-model="addressPopup"
            :close-on-click-overlay="false"
            :style="{ height: '70%' }"
            position="bottom"
        >
            <div class="chooseAddress-w">
                <div class="title-fixed">
                    <div class="title-bar">
                        <span class="title-label" v-if="istitle">为了后期开展区域化，请选择您的所在地区</span>
                        <span class="title-label" v-else-if='title'>{{ title }}</span>
                        <span class="title-label" v-else>配送地址</span>
                        <span class="close-btn" @click="closePopup">&times;</span>
                    </div>
                    <div class="address-text">
                        <template v-if="addrArr.length > 0">
                            <span
                                class="adr-item"
                                v-for="(item,index) in addrArr"
                                :key="index"
                                @click="chooseAdrItem(item.c, index)"
                            >
                                {{ item.n }}
                                <i class="sep" v-if="index < addrArr.length - 1"></i>
                            </span>
                        </template>
                        <span class="adr-placeholder" v-else>请选择省/市/区</span>
                    </div>
                </div>
                <div class="address-content2">
                    <div class="address-box">
                        <div
                            class="address-item"
                            v-for="(item, index) in addressList"
                            :key="item.c"
                            :class="{ active: index === activeIndex }"
                            @click="chooseAddress(item)"
                        >
                            <span class="item-dot" v-if="index === activeIndex"></span>
                            <span class="item-text">{{ item.n }}</span>
                            <i class="item-chevron"></i>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
import newhttps from './../../cmmon/js/newhttps'
export default {
    name: 'addressTemp',
    props: {
        addressPopup: {
            type: Boolean,
            default: false
        },
        addr: {
            type: Array,
            default: []
        },
        sendList: {
            type: Array,
            default: []
        },
        selectLimit:{
            type:Number,
            default:0
        },
        title:{
            type:String,
            default:''
        },
        istitle:false,
        regionalScope:'',
    },
    data(){
        return{
            activeIndex: null,
            addressList: [],
            addrText: '',
            addrArr: [],
            province: '',
            city: '',
            area: '',
            town: ''
        }
    },
    created() {
        this.addrArr = this.addr
        if (this.addr.length < 4) {
            this.addrArr = []
            this.getAddrLibrary()
        } else {
            this.getAddrLibrary(this.addr[this.addr.length - 2].c, false)
        }

    },
    methods:{
        //获取地址库
        getAddrLibrary(root, state,limit) {
            let key = ''
            if (root) {
                key = `?key=${root}`
            } else {
                key = ''
            }
            newhttps.get('storage/public/address/base' + key).then(res =>{
                if (res.data === null) {
                    if (state) {
                        this.$emit('closePopup')
                        this.$emit('getAddr', this.addrArr)
                        this.restData()
                    }
                } else {
                    if (this.sendList.length > 0 && key === '') {
                        this.addressList = this.sendList
                    } else {
                        this.addressList = res.data
                    }
                    // 列表更新后重置滚动位置和高亮
                    this.activeIndex = null
                    this.$nextTick(() => {
                        const scrollEl = this.$el.querySelector('.address-content2')
                        if (scrollEl) {
                            scrollEl.scrollTop = 0
                        }
                    })
                }
            })
        },
        //点击选择地址
        chooseAddress(item) {
            // console.log(item,this.$props.regionalScope,'scope')
            this.addrText += item.n
            if (this.addrArr.length < 4) {
                this.addrArr.push(item)
            }
            if (this.addrArr.length === 4) {
                this.addrArr.splice(3, 1)
                this.addrArr.push(item)
            }
            if(this.$props.regionalScope==1){
                this.$emit('closePopup')
                this.$emit('getAddr', this.addrArr)
                this.restData()
                return
            }
            if(this.$props.regionalScope==2 && item.c.length==4){
                this.$emit('closePopup')
                this.$emit('getAddr', this.addrArr)
                this.restData()
                return
            }
            if(this.$props.regionalScope==3 && item.c.length==6){
                this.$emit('closePopup')
                this.$emit('getAddr', this.addrArr)
                this.restData()
                return
            }
            if(this.selectLimit == 2&&this.addrArr.length ==2 ){
                // 母婴级别审核选择地址
                this.$emit('changeselect', false)
                this.$emit('getAddr', this.addrArr)
                // this.getAddrLibrary(item.c, true)
                this.restData()
                return
            }
            this.getAddrLibrary(item.c, true)
        },
        // 点击选择好的省市区重新更换
        chooseAdrItem(code, index) {
            if (code.length === 2) {
                this.getAddrLibrary()
                this.addrArr = []
            }
            if (code.length === 4) {
                this.getAddrLibrary(this.addrArr[0].c)
                this.addrArr.splice(1, this.addrArr.length - 1)
            }
            if (code.length === 6) {
                this.getAddrLibrary(this.addrArr[1].c)
                this.addrArr.splice(2, this.addrArr.length - 1)
            }
            // this.addrArr.splice(index + 1, this.addrArr.length - 1)
        },
        closePopup() {
            this.$emit('closePopup')
            // this.restData()
        },
        restData() {
            this.addrText = ''
            this.addressList = []
            this.addrArr = []
            this.getAddrLibrary()
        }
    }
}
</script>
<style lang="less" scoped>
.chooseAddress-w {
    background: #fff;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border-radius: 12px 12px 0 0;

    /* ====== 顶部固定区域 ====== */
    .title-fixed {
        flex-shrink: 0;
        background: #fff;
        z-index: 10;
    }
    .title-bar {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        height: 48px;
        padding: 0 15px;
        .title-label {
            font-size: 12px;
            font-weight: 600;
            color: #1a1a1a;
            letter-spacing: 0.5px;
        }
        .close-btn {
            position: absolute;
            right: 12px;
            top: 50%;
            transform: translateY(-50%);
            width: 24px;
            height: 24px;
            line-height: 22px;
            text-align: center;
            font-size: 20px;
            color: #999;
            border-radius: 50%;
            background: #f5f5f5;
            font-style: normal;
            transition: all 0.2s;
            &:active {
                background: #e8e8e8;
                color: #666;
            }
        }
    }

    /* ====== 面包屑导航 ====== */
    .address-text {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        overflow-x: auto;
        padding: 8px 15px 10px;
        border-bottom: 1px solid #f0f0f0;
        -webkit-overflow-scrolling: touch;
        &::-webkit-scrollbar {
            display: none;
        }
        .adr-placeholder {
            font-size: 13px;
            color: #bbb;
        }
        .adr-item {
            display: flex;
            align-items: center;
            flex-shrink: 0;
            font-size: 13px;
            color: #4a90d9;
            font-weight: 500;
            padding: 3px 8px;
            background: #eef4ff;
            border-radius: 3px;
            transition: all 0.2s;
            &:active {
                background: #d8e8ff;
            }
            .sep {
                display: inline-block;
                width: 0;
                height: 0;
                margin-left: 6px;
                border-top: 4px solid transparent;
                border-bottom: 4px solid transparent;
                border-left: 5px solid #c0d4f0;
                font-style: normal;
            }
        }
    }

    /* ====== 地址列表滚动区域 ====== */
    .address-content2 {
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch;
        &::-webkit-scrollbar {
            width: 3px;
        }
        &::-webkit-scrollbar-track {
            background: transparent;
        }
        &::-webkit-scrollbar-thumb {
            background: #ddd;
            border-radius: 3px;
        }
    }
    .address-box {
        padding: 5px 0 30px;
    }

    /* ====== 每一行地址 ====== */
    .address-item {
        display: flex;
        align-items: center;
        position: relative;
        min-height: 48px;
        padding: 0 15px 0 13px;
        font-size: 14px;
        color: #333;
        transition: background-color 0.15s;
        &:active {
            background-color: #f7f9fc;
        }

        /* 左侧小圆点指示器 */
        .item-dot {
            display: block;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: #4a90d9;
            margin-right: 7px;
            flex-shrink: 0;
        }

        /* 文字 */
        .item-text {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding: 12px 0;
            border-bottom: 1px solid #f5f5f5;
        }

        /* 右侧箭头 */
        .item-chevron {
            display: block;
            width: 8px;
            height: 8px;
            flex-shrink: 0;
            margin-left: 6px;
            border-top: 1.5px solid #ccc;
            border-right: 1.5px solid #ccc;
            transform: rotate(45deg);
            transition: border-color 0.2s;
        }

        /* 选中态 */
        &.active {
            color: #4a90d9;
            .item-text {
                font-weight: 600;
                color: #4a90d9;
            }
            .item-chevron {
                border-color: #4a90d9;
            }
        }
    }

    /* 最后一行去掉下划线 */
    .address-item:last-child .item-text {
        border-bottom: none;
    }

    .ceshis {
        width: 100%;
        height: 100px;
    }
}
</style>